import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const employeeLeaveLocaleModule: LocaleModule = {
  name: "employeeLeave",
  messages: { en: en, it: it },
};
